/**
 * Hinweis, wenn auf dem Server eine neue Version liegt: Der Tab fragt regelmäßig und beim Zurückkehren
 * dist/version.json ab und vergleicht die Kennung mit der eigenen. Der Spielstand liegt im Browser
 * (und mit Konto in der Cloud), Neuladen ist also sicher.
 */
import { useEffect, useState } from 'react';
import { status } from '../multiplayer/sync';
import { track } from '../../lib/telemetry';

const EVERY = 5 * 60 * 1000;
const TRIED = 'kabinett-update-tried';

/** Neu laden und dabei den Browser-Cache für die Seite umgehen (eigener Parameter in der Adresse). */
function reloadFresh(build: string) {
  try { sessionStorage.setItem(TRIED, build); } catch { /* egal */ }
  const u = new URL(window.location.href); u.searchParams.set('v', build);
  window.location.replace(u.toString());
}
/** Nach dem Neuladen den Parameter wieder aus der Adresse nehmen. */
if (typeof window !== 'undefined') {
  try { const u = new URL(window.location.href); if (u.searchParams.has('v')) { u.searchParams.delete('v'); window.history.replaceState(window.history.state, '', u.toString()); } } catch { /* egal */ }
}
const MINE = typeof __BUILD_ID__ === 'string' ? __BUILD_ID__ : 'dev';

async function latest(): Promise<string | null> {
  try {
    const r = await fetch(`/version.json?t=${Date.now()}`, { cache: 'no-store' });
    if (!r.ok) return null;
    const j = await r.json(); return typeof j?.build === 'string' ? j.build : null;
  } catch { return null; }
}

export function UpdateBanner() {
  const [next, setNext] = useState<string | null>(null);
  const [hidden, setHidden] = useState(false);
  useEffect(() => {
    if (import.meta.env.DEV) return;
    let off = false;
    const check = async () => { const b = await latest(); if (!off && b && b !== MINE) setNext(b); };
    const t = setInterval(check, EVERY);
    const onVis = () => { if (document.visibilityState === 'visible') void check(); };
    document.addEventListener('visibilitychange', onVis); window.addEventListener('focus', onVis);
    void check();
    return () => { off = true; clearInterval(t); document.removeEventListener('visibilitychange', onVis); window.removeEventListener('focus', onVis); };
  }, []);
  // Schon einmal für genau diese Version neu geladen und trotzdem noch die alte? Dann nicht weiter drängeln
  // (z. B. wenn der Server noch eine alte index.html ausliefert oder die Dateien noch hochgeladen werden).
  const tried = (() => { try { return sessionStorage.getItem(TRIED) === next; } catch { return false; } })();
  if (!next || hidden || tried) return null;
  const pending = status()?.pending ?? 0;
  return (
    <div className="updatebar" role="status">
      <div><b>Neue Version von Kabinett verfügbar.</b> <span className="sub">Lade die Seite neu, um die neueste Version zu spielen. Dein Spielstand bleibt erhalten.{pending ? ` Es sind noch ${pending} Züge unterwegs, warte kurz, bis sie angekommen sind.` : ''}</span></div>
      <div className="actions">
        <button type="button" className="yes small" onClick={() => { track('App.updateReload', {}); reloadFresh(next); }}>Jetzt neu laden</button>
        <button type="button" className="small" onClick={() => setHidden(true)}>Später</button>
      </div>
    </div>
  );
}
